import { Form, Input, Modal } from "antd";

import type { Milestone } from "@/views/PlanOfRecord/planOfRecordData";

export function DeleteMilestoneModal({
  milestone,
  onCancel,
  onConfirm,
}: {
  milestone: Milestone | null;
  onCancel: () => void;
  onConfirm: (rationale: string) => void;
}) {
  const [form] = Form.useForm<{ rationale: string }>();

  return (
    <Modal
      open={!!milestone}
      title={`Delete ${milestone?.label ?? ""}?`}
      okText="Delete milestone"
      okButtonProps={{ danger: true }}
      onCancel={onCancel}
      onOk={async () => {
        let values: { rationale: string };
        try {
          values = await form.validateFields();
        } catch {
          return;
        }
        onConfirm(values.rationale);
        form.resetFields();
      }}
      destroyOnHidden
    >
      <p className="mb-4 text-[12px] leading-relaxed text-[#6B7280]">
        The milestone leaves the plan. This cannot be undone from here — the
        rationale is recorded, but there is no way to view a deleted milestone's
        history through this screen afterward.
      </p>

      <Form form={form} layout="vertical" requiredMark={false}>
        <Form.Item
          name="rationale"
          label="Why is this being deleted?"
          rules={[
            { required: true, message: "A rationale is required." },
            {
              min: 10,
              message: "Give enough detail to be useful in six months.",
            },
          ]}
        >
          <Input.TextArea
            rows={3}
            placeholder="e.g. Duplicated the study-level activation milestone."
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
